import {getResource} from "./common"

export type PrimeLoanRate = {
	type: "primeLoanRate"
	id: string
	attributes: {
		rate: number
		effectiveDate: string
	}
}

export const getPrimeLoanRate = async (accessToken: string) =>
	await getResource<PrimeLoanRate>(`receivables/prime-loan-rate/`, accessToken)
